const data = [{
    id: 1,
    icon: "⭕️",
    status: "open",
    title: "Tintcat",
    content: "This is an application about Tintcat"
}, {
    id: 2,
    icon: "⭕️",
    status: "open",
    title: "Amazon page",
    content: "This is an application about mock-up Amazon page"
}, {
    id: 3,
    icon: "⭕️",
    status: "open",
    title: "Fix bugs",
    content: "This is an application about fix bugs"
}, {
    id: 4,
    icon: "⭕️",
    status: "open",
    title: "Sprinters",
    content: "This is an application about project management"
}];

const statuses = [{
    status: "open",
    icon: "⭕️",
    color: "#EB5A46"
}, {
    status: "in progress",
    icon: "🔆️",
    color: "#00C2E0"
}, {
    status: "in review",
    icon: "📝",
    color: "#C377E0"
}, {
    status: "done",
    icon: "✅",
    color: "#3981DE"
}];


export { data, statuses };